// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"524":"5d3ac02e7af23c56","606":"bd260d73652d9325","998":"d73dd74c429ef639"}[chunkId] + ".js";
};